// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d6-j";
export var fulfillmentFormRail = "_d6-i";
export var headerTitleRow = "_d6-l";
export var orderDetailsWrapper = "_d6-g";
export var orderLinkTrigger = "_d6-2";
export var paymentInformationGrid = "_d6-q";
export var paymentSummaryColumn = "_d6-r";
export var phoneShipmentPickerButton = "_d6-e";
export var phoneShipmentPickerButtonContent = "_d6-f";
export var phoneShipmentPickerButtonWrapper = "_d6-d";
export var phoneShipmentPickerTrigger = "_d6-c";
export var shipmentContainer = "_d6-k";
export var shipmentDetailsMainPane = "_d6-h";
export var shipmentNavigationCard = "_d6-a";
export var shipmentNavigationEdgeTrigger = "_d6-6";
export var shipmentNavigationRail = "_d6-3";
export var shipmentNavigationRailEnter = "_d6-5";
export var shipmentNavigationRailHeader = "_d6-9";
export var shipmentNavigationRailOverlay = "_d6-4";
export var shipmentNavigationScrim = "_d6-7";
export var shipmentSummaryFact = "_d6-n";
export var shipmentSummaryGrid = "_d6-m";
export var shipmentSummaryMetadataRow = "_d6-o";
export var shipmentSummaryTags = "_d6-p";
export var shipmentWorkspace = "_d6-0";
export var shipmentWorkspaceBodyTablet = "_d6-8";
export var shipmentWorkspaceContent = "_d6-b";
export var shipmentWorkspaceHeader = "_d6-1";